var NavToolbarContentComponent_1;
import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./nav-toolbar-content.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./nav-toolbar-content.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Output } from "@angular/core";
import { AuthService } from "../../../shared/services/auth/auth.service";
import { NavConstants } from "../nav.constants";
import { NavigationEnd, NavigationStart, Router } from "@angular/router";
import { Link } from "../../../shared/models/link.model";
import { AppControllerService } from "../../../app-controller.service";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { AppConfig } from "../../../app.config";
import { ViewApplicationRoutingConstants } from "../../../application/view-application/view-application-routing.constants";
import { SystemModuleSettingsService } from "../../../shared/services/system-module-settings.service";
import { UserInformationService } from "../../../shared/services/user/user-information.service";
import { MapServiceService } from "../../settings/shared/map-service.service";
import { aflaModuleServiceProvider } from "../../../shared/services/afla-module-strategy/afla-module-strategy.service.provider";
import { DatePipe } from "@angular/common";
import { ModuleConfigService } from "../../../shared/services/module-config/module-config.service";
import { PropertiesRoutingConstants } from "../../../tabs/properties/properties-routing.constants";
import { ApplicationsRoutingConstants } from "../../../tabs/applications/applications-routing.constants";
import { ArcgisItemsRoutingConstants } from "../../../tabs/arcgis-items/arcgis-items-routing.constants";
import { ServerNotificationService } from "../../../shared/services/server-notification/server-notification.service";
import { BaysRoutingConstants } from "../../../tabs/bays/bays-routing.constants";
import { GravesRoutingConstants } from "../../../tabs/graves/graves-routing.constants";
import { POIRoutingConstants } from "../../../tabs/poi/poi-routing.constants";
import { StreetsRoutingConstants } from "../../../tabs/streets/streets.routing.constants";
import { NavToolbarContentConstants } from "./nav-toolbar-content.constants";
import { AutoUnsub } from "../../../shared/decorators/autounsub.decorator";
import { NavToolbarContentService } from "./nav-toolbar-content.service";
import { CreateApplicationRoutingConstants } from "../../../application/create-application/create-application-routing.constants";
import { AlertType } from "../../../shared/models/alert";
import { FileUtils } from "../../../shared/utils/file-utils";
import { FeatureSearchRoutingConstants } from "src/app/search/feature-search/feature-search-routing.constants";
import { ApplicationSearchRoutingConstants } from "../../../search/application-search/application-search-routing.constants";
import { CRUDOperation } from "../../../shared/models/crud-operation-enum.model";
let NavToolbarContentComponent = class NavToolbarContentComponent {
    static { NavToolbarContentComponent_1 = this; }
    authService;
    router;
    appControllerService;
    systemModuleSettingsService;
    userInformationService;
    mapService;
    changeDetectorRef;
    serverNotificationService;
    datePipe;
    appConfig;
    moduleConfigService;
    navToolbarContentService;
    sideNavToggle = new EventEmitter();
    appTitle = NavConstants.APP_TITLE;
    $authenticated;
    headingLinks;
    showHeadings;
    notificationIsOn = false;
    showHelpLink = false;
    $systemModuleSettingsFetched;
    $userInformationFetched;
    notificationList = [];
    activeRoute;
    headingRoutes;
    propertyLayersForModules;
    helpInfoText = NavToolbarContentConstants.HELP_TOOLTIP;
    notifications = NavToolbarContentConstants.NOTIFICATION_TOOLTIP;
    settingsSubscription;
    subscribToStrategyServiceSubscription;
    eventsSubscription;
    messageReceivedSubscription;
    layerUrlListAsObservableSubscription;
    $systemModuleSettingsFetchedSubscription;
    noHelpFileMessage = NavToolbarContentConstants.NO_HELP_FILE_MESSAGE;
    noModuleSelected = NavToolbarContentConstants.NO_MODULE_SELECTED;
    constructor(authService, router, appControllerService, systemModuleSettingsService, userInformationService, mapService, changeDetectorRef, serverNotificationService, datePipe, appConfig, moduleConfigService, navToolbarContentService) {
        this.authService = authService;
        this.router = router;
        this.appControllerService = appControllerService;
        this.systemModuleSettingsService = systemModuleSettingsService;
        this.userInformationService = userInformationService;
        this.mapService = mapService;
        this.changeDetectorRef = changeDetectorRef;
        this.serverNotificationService = serverNotificationService;
        this.datePipe = datePipe;
        this.appConfig = appConfig;
        this.moduleConfigService = moduleConfigService;
        this.navToolbarContentService = navToolbarContentService;
        this.settingsSubscription = this.appConfig.$settings.subscribe(settings => {
            if (settings !== null) {
                AppConfig.settings = settings;
                if (AppConfig.settings.getHelpUrl !== "" && AppConfig.settings.getHelpUrl !== undefined && AppConfig.settings.getHelpUrl !== null) {
                    this.showHelpLink = true;
                }
                this.appTitle = AppConfig.settings.projectSettings.projectName;
            }
        });
        this.$authenticated = this.authService.$isAuthenticated;
        this.$systemModuleSettingsFetched = this.systemModuleSettingsService.$systemModuleSettingsFetched;
        this.$userInformationFetched = this.userInformationService.$userInformationFetched;
    }
    static getLink(headingText, address, selectedSystemModuleID) {
        return new Link(headingText, AppRoutingConstants.createRouteToViewWithPrefixRouteSeparator(selectedSystemModuleID, address));
    }
    ngOnInit() {
        this.addHeadingLinks();
        this.populateHeadingRoutes();
        this.setActivatedRoute();
        this.listenForRouteChanges();
        this.checkMapServicePropertyLayer();
        // this.subscibToNoticfications();
    }
    showNotification() {
        this.notificationIsOn = !this.notificationIsOn;
    }
    clickOutsideNotification() {
        if (this.notificationIsOn) {
            this.notificationIsOn = false;
        }
    }
    toggleSideNav() {
        this.sideNavToggle.emit();
    }
    routeToUpdateProfile() {
        const url = `${AppConfig.settings.ids.issuer}/AccountManagement?url=${AppConfig.settings.ids.redirectUri}&appName=${AppConfig.settings.applicationAlias}&clientId=${AppConfig.settings.ids.clientId}`;
        window.open(url, "_self");
    }
    subscibToNoticfications() {
        this.messageReceivedSubscription = this.serverNotificationService.messageReceived.subscribe((notificationModel) => {
            if (this.serverNotificationService.getNotificationObservableValue()) {
                this.notificationList = this.serverNotificationService.getNotificationObservableValue();
            }
            notificationModel.createdDate = this.datePipe.transform(notificationModel.createdDate, "yyyy-MM-dd");
            this.notificationList.unshift(notificationModel);
            this.serverNotificationService.newNotificationObservable(this.notificationList);
        });
    }
    checkMapServicePropertyLayer() {
        this.layerUrlListAsObservableSubscription = this.mapService.layerUrlListAsObservable.subscribe((data) => {
            if (data && data.length > 0) {
                this.propertyLayersForModules = data;
                this.changeDetectorRef.detectChanges();
            }
        });
    }
    addHeadingLinks() {
        this.$systemModuleSettingsFetchedSubscription = this.systemModuleSettingsService.$systemModuleSettingsFetched.subscribe({
            next: (settingsFetched) => {
                if (settingsFetched) {
                    const selectedSystemModuleID = this.appControllerService.selectedModuleID;
                    this.clearHeadings();
                    this.addDefaultHeadingsStart(selectedSystemModuleID);
                    this.addHeadingsForPropertiesTabLink(selectedSystemModuleID);
                    this.addHeadingsForGraveTabLink(selectedSystemModuleID);
                    this.addHeadingsForBayTabLink(selectedSystemModuleID);
                    this.addHeadingsForPOITabLink(selectedSystemModuleID);
                    this.addHeadingsForStreetsTabLink(selectedSystemModuleID);
                    this.addDefaultHeadingsLinks(selectedSystemModuleID);
                    if (AppConfig.settings.showNewFeatureSearch !== "" && AppConfig.settings.showNewFeatureSearch !== null && AppConfig.settings.showNewFeatureSearch !== undefined && AppConfig.settings.showNewFeatureSearch === "true") {
                        this.addHeadingsForFeatureSearchLink(selectedSystemModuleID);
                    }
                    if (AppConfig.settings.showNewApplicationSearch !== "" && AppConfig.settings.showNewApplicationSearch !== null && AppConfig.settings.showNewApplicationSearch !== undefined && AppConfig.settings.showNewApplicationSearch === "true") {
                        this.addHeadingsForApplicationSearchLink(selectedSystemModuleID);
                    }
                }
            }
        });
        this.subscribToStrategyServiceSubscription = this.systemModuleSettingsService.$subscribToStrategyService.subscribe(s => {
            if (this.headingLinks && this.headingLinks.length > 0) {
                const index = this.headingLinks.findIndex(d => d.text === NavConstants.APPLICATIONS_HEADING_TEXT);
                if (index > -1 && s && s.Applications) {
                    this.headingLinks[index].text = s.Applications;
                }
                this.changeDetectorRef.markForCheck();
            }
        });
        this.changeDetectorRef.markForCheck();
    }
    listenForRouteChanges() {
        this.eventsSubscription = this.router.events
            .subscribe((event) => {
            this.reactToRouteChanges(event);
        });
    }
    reactToRouteChanges(event) {
        if (event instanceof NavigationStart) {
            this.handleNavigationStart();
        }
        if (event instanceof NavigationEnd) {
            this.handleNavigationEnd(event);
        }
    }
    checkIfHeadingRoute(event) {
        return this.headingRoutes.some((headingRoute) => {
            return event.urlAfterRedirects.includes(headingRoute);
        });
    }
    clearHeadings() {
        this.headingLinks = new Array();
    }
    handleNavigationEnd(event) {
        this.activeRoute = event.urlAfterRedirects;
        this.showHeadings = this.checkIfHeadingRoute(event);
        if (this.showHeadings) {
            this.clearHeadings();
            this.addHeadingLinks();
        }
    }
    populateHeadingRoutes() {
        this.headingRoutes = new Array(ViewApplicationRoutingConstants.VIEW_APPLICATION_ROUTE, CreateApplicationRoutingConstants.CREATE_APPLICATION_ROUTE, "createapplication", ApplicationsRoutingConstants.APPLICATIONS_ROUTE, PropertiesRoutingConstants.PROPERTIES_ROUTE, BaysRoutingConstants.BAYS_ROUTE, POIRoutingConstants.POI_ROUTE, StreetsRoutingConstants.STREETS_ROUTE, GravesRoutingConstants.GRAVES_ROUTE, ArcgisItemsRoutingConstants.ARCGIS_ITEMS_ROUTE, FeatureSearchRoutingConstants.FEATURE_SEARCH_ROUTE, ApplicationSearchRoutingConstants.APPLICATION_SEARCH_ROUTE);
    }
    setActivatedRoute() {
        this.activeRoute = this.router.routerState.snapshot.url;
    }
    handleNavigationStart() {
        this.clearHeadings();
    }
    addHeadingsForPropertiesTabLink(selectedSystemModuleID) {
        if (this.appControllerService.selectedModuleID !== undefined && this.appControllerService.selectedModuleID !== null
            && +this.appControllerService.selectedModuleID > 0 && !this.moduleConfigService.isCemeteryModule() && !this.moduleConfigService.isInformalTradeModule() && !this.moduleConfigService.isMondiModule()) {
            this.headingLinks.push(NavToolbarContentComponent_1
                .getLink(NavConstants.PROPERTIES_HEADING_TEXT, PropertiesRoutingConstants.PROPERTIES_ROUTE, selectedSystemModuleID));
        }
    }
    addHeadingsForGraveTabLink(selectedSystemModuleID) {
        if (this.appControllerService.selectedModuleID !== undefined && this.appControllerService.selectedModuleID !== null
            && +this.appControllerService.selectedModuleID > 0 && this.moduleConfigService.isCemeteryModule()) {
            this.headingLinks.push(NavToolbarContentComponent_1
                .getLink(NavConstants.GRAVES_HEADING_TEXT, GravesRoutingConstants.GRAVES_ROUTE, selectedSystemModuleID));
        }
    }
    addHeadingsForBayTabLink(selectedSystemModuleID) {
        if (this.appControllerService.selectedModuleID !== undefined && this.appControllerService.selectedModuleID !== null
            && +this.appControllerService.selectedModuleID > 0 && this.moduleConfigService.isInformalTradeModule()) {
            this.headingLinks.push(NavToolbarContentComponent_1
                .getLink(NavConstants.BAYS_HEADING_TEXT, BaysRoutingConstants.BAYS_ROUTE, selectedSystemModuleID));
        }
    }
    addHeadingsForPOITabLink(selectedSystemModuleID) {
        if (this.appControllerService.selectedModuleID !== undefined && this.appControllerService.selectedModuleID !== null
            && +this.appControllerService.selectedModuleID > 0 && this.moduleConfigService.isStreetNamingModule()) {
            this.headingLinks.push(NavToolbarContentComponent_1
                .getLink(NavConstants.POI_HEADING_TEXT, POIRoutingConstants.POI_ROUTE, selectedSystemModuleID));
        }
    }
    addHeadingsForStreetsTabLink(selectedSystemModuleID) {
        if (this.appControllerService.selectedModuleID !== undefined && this.appControllerService.selectedModuleID !== null
            && +this.appControllerService.selectedModuleID > 0 && this.moduleConfigService.isStreetNamingModule()) {
            this.headingLinks.push(NavToolbarContentComponent_1
                .getLink(NavConstants.STREETS_HEADING_TEXT, StreetsRoutingConstants.STREETS_ROUTE, selectedSystemModuleID));
        }
    }
    addDefaultHeadingsStart(selectedSystemModuleID) {
        this.headingLinks.push(NavToolbarContentComponent_1
            .getLink(NavConstants.APPLICATIONS_HEADING_TEXT, ApplicationsRoutingConstants.APPLICATIONS_ROUTE, selectedSystemModuleID));
    }
    addDefaultHeadingsLinks(selectedSystemModuleID) {
        this.headingLinks.push(NavToolbarContentComponent_1
            .getLink(NavConstants.ARCGIS_ITEMS_HEADING_TEXT, ArcgisItemsRoutingConstants.ARCGIS_ITEMS_ROUTE, selectedSystemModuleID));
    }
    getHelpClicked() {
        const moduleId = this.appControllerService.selectedModuleID;
        if (!moduleId) {
            this.appControllerService.showMessage(this.noModuleSelected, AlertType.Warning);
            return;
        }
        this.navToolbarContentService.getHelpFileWithFileName(+moduleId).subscribe({
            next: (result) => {
                if (result.blob) {
                    FileUtils.openFile(result.fileName, result.blob);
                }
                else {
                    this.appControllerService.showMessage(this.noHelpFileMessage, AlertType.Warning);
                }
            },
            error: (error) => {
                if (error.status === 404) {
                    this.appControllerService.showMessage(this.noHelpFileMessage, AlertType.Warning);
                }
                else {
                    this.appControllerService.handleServerErrorMessage(NavToolbarContentConstants.FILE_NAME_HELP, error, CRUDOperation.Get);
                }
            }
        });
    }
    addHeadingsForFeatureSearchLink(selectedSystemModuleID) {
        if (this.appControllerService.selectedModuleID !== undefined && this.appControllerService.selectedModuleID !== null
            && +this.appControllerService.selectedModuleID > 0 && !this.moduleConfigService.isMondiModule()) {
            this.headingLinks.push(NavToolbarContentComponent_1
                .getLink(NavConstants.FEATURE_SEARCH_HEADING_TEXT, FeatureSearchRoutingConstants.FEATURE_SEARCH_ROUTE, selectedSystemModuleID));
        }
    }
    addHeadingsForApplicationSearchLink(selectedSystemModuleID) {
        if (this.appControllerService.selectedModuleID !== undefined && this.appControllerService.selectedModuleID !== null
            && +this.appControllerService.selectedModuleID > 0 && !this.moduleConfigService.isMondiModule()) {
            this.headingLinks.push(NavToolbarContentComponent_1
                .getLink(NavConstants.APPLICATION_SEARCH_HEADING_TEXT, ApplicationSearchRoutingConstants.APPLICATION_SEARCH_ROUTE, selectedSystemModuleID));
        }
    }
    static ctorParameters = () => [
        { type: AuthService },
        { type: Router },
        { type: AppControllerService },
        { type: SystemModuleSettingsService },
        { type: UserInformationService },
        { type: MapServiceService },
        { type: ChangeDetectorRef },
        { type: ServerNotificationService },
        { type: DatePipe },
        { type: AppConfig },
        { type: ModuleConfigService },
        { type: NavToolbarContentService }
    ];
    static propDecorators = {
        sideNavToggle: [{ type: Output }]
    };
};
NavToolbarContentComponent = NavToolbarContentComponent_1 = __decorate([
    Component({
        standalone: false,
        selector: "app-nav-toolbar-content",
        providers: [aflaModuleServiceProvider],
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], NavToolbarContentComponent);
export { NavToolbarContentComponent };
